const initialState = {
    data: [],
  };
  
const planowaneZuzycieUReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PLANOWANE_ZUZYCIE_U':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default planowaneZuzycieUReducer;